import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceNullValue'
})
export class ReplaceNullValuePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if (value == undefined || value == null || value === '')
      return '-';
    if (typeof value === 'string' && value.trim() === '')
      return '-';
    return value;
  }

}
